export default function initializeMultiselectValue(selectedOptions, valueKey) {
    return selectedOptions.map(selectedOption => selectedOption[valueKey]);
}